export const initBlockVisibility = {
  limitByDate: false,
  visible_from: null,
  visible_until: null,
  limitByCriteria: false,
  visibility_criterion_ids: [],
}

export const alwaysVisiblePayload = {
  visible_from: null,
  visible_until: null,
  visibility_criterion_ids: [],
}
